import Config from '@config';
import { initializeServicesApi } from '@gasbi/shared/common/features/services';

import axiosBaseQuery from '@/utils/axiosBaseQuery';

const initializedServicesApi = initializeServicesApi({
  baseUrl: Config.VITE_API_URL,
  baseQuery: axiosBaseQuery,
});

export const servicesApi = initializedServicesApi.servicesApi.enhanceEndpoints({
  addTagTypes: ['UserServices'],
  endpoints: {
    getUserServices: {
      providesTags: ['UserServices'],
    },
  },
});

export const { useGetUserServicesQuery } = servicesApi;
